<template>
  <div class="snapshot-wrap">
    <div class="stock-info">
      <span class="name">{{ $digitjs(snapshot.name).isNull() }}</span>
      <span class="symbol">{{ $digitjs(snapshot.symbol).replace(/(\.hk|\.us|\.sz|\.sh)/gi) }} </span>
    </div>
    <div class="stock-close" :style="{ color: $digitjs(snapshot.change).color() }">
      <span class="close">
        {{ $digitjs(snapshot.close).rounded(3) }}
        <!-- <i v-if="snapshot.change > 0" class="iconfont icon-xiangshang4"></i>
        <i v-if="snapshot.change < 0" class="iconfont icon-xiangxia4"></i> -->
      </span>
      <span class="change">{{ $digitjs(snapshot.change).prefix().rounded(3) }}</span>
      <span class="rate">{{ $digitjs(snapshot.changeRate).prefix().unit('%').rounded() }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      snapshot: {}
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    this.getSnapshot()
  },
  methods: {
    async getSnapshot() {
      const res = await this.$post(this.$api.sdk[this.market] + '/stock/quote', {
        fields: ['snapshot'],
        symbols: [this.symbol],
        timeMode: 0
      })
      const { symbol, name, nameCn, nameEn, snapshot } = res.body?.[0] ?? {}
      snapshot.symbol = symbol
      snapshot.name = name ?? nameCn ?? nameEn
      this.snapshot = snapshot
    }
  }
}
</script>

<style lang="scss" scoped>
.snapshot-wrap {
  padding: 15px;
  border-bottom: 1px solid var(--border-color-1);
  .name {
    font-size: 18px;
    margin-bottom: 8px;
  }
  .symbol {
    margin-left: 4px;
    font-size: 14px;
    color: var(--font-color-3);
  }
  .stock-close {
    font-size: 24px;
    .iconfont {
      font-size: 12px;
    }
  }
  .close,
  .change {
    margin-right: 32px;
  }
}
</style>
